import createjs from "createjs";
import '../pathseg'
import Box2D from '../box2d'

const map = (function (createjs, Box2D) {

    //.animation-position-helper
    var mainContainer;

    const ART_W = 318
    const ART_H = 285


    
    var canvas1
    var stage
    var AdobeAn = {}
    var map;
    var rsc;
    var paused;
    
    var start2dSim;

    (function (cjs, an) {

        var p // shortcut to reference prototypes
        var lib = {}
        var ss = {}
        var img = {}
        lib.ssMetadata = [
            {
                name: 'bentiu_atlas_',
                frames: [[650, 60, 49, 49], [695, 0, 16, 16], [650, 0, 43, 58], [0, 0, 648, 583]]
      }
    ];


        // symbols:


        (lib.CachedTexturedBitmap_2 = function () {
            this.initialize(ss['bentiu_atlas_'])
            this.gotoAndStop(0)
        }).prototype = p = new cjs.Sprite();


        (lib.CachedTexturedBitmap_3 = function () {
            this.initialize(img.CachedTexturedBitmap_3)
        }).prototype = p = new cjs.Bitmap()
        p.nominalBounds = new cjs.Rectangle(0, 0, 2299, 2299);


        (lib.CachedTexturedBitmap_4 = function () {
            this.initialize(ss['bentiu_atlas_'])
            this.gotoAndStop(1)
        }).prototype = p = new cjs.Sprite();


        (lib.CachedTexturedBitmap_5 = function () {
            this.initialize(ss['bentiu_atlas_'])
            this.gotoAndStop(2)
        }).prototype = p = new cjs.Sprite();


        (lib.CachedTexturedBitmap_7 = function () {
            this.initialize(ss['bentiu_atlas_'])
            this.gotoAndStop(3)
        }).prototype = p = new cjs.Sprite()

        // helper functions:

        function mc_symbol_clone() {
            var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop))
            clone.gotoAndStop(this.currentFrame)
            clone.paused = this.paused
            clone.framerate = this.framerate
            return clone
        }

        function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
            var prototype = cjs.extend(symbol, cjs.MovieClip)
            prototype.clone = mc_symbol_clone
            prototype.nominalBounds = nominalBounds
            prototype.frameBounds = frameBounds
            return prototype
        }


        (lib.Symbol5 = function (mode, startPosition, loop) {
            this.initialize(mode, startPosition, loop, {})

            // Layer_1
            this.instance = new lib.CachedTexturedBitmap_5()
            this.instance.parent = this
            this.instance.setTransform(-0.5, -0.5, 0.5, 0.5)

            this.timeline.addTween(cjs.Tween.get(this.instance).wait(1))

        }).prototype = getMCSymbolPrototype(lib.Symbol5, new cjs.Rectangle(-0.5, -0.5, 21.5, 29), null);


        (lib.Symbol2 = function (mode, startPosition, loop) {
            this.initialize(mode, startPosition, loop, {})

            // Layer_1
            this.instance = new lib.CachedTexturedBitmap_3()
            this.instance.parent = this
            this.instance.setTransform(0, 0, 0.1138, 0.1138)

            this.timeline.addTween(cjs.Tween.get(this.instance).wait(1))

        }).prototype = getMCSymbolPrototype(lib.Symbol2, new cjs.Rectangle(0, 0, 261.7, 261.7), null);


        (lib.Oval = function (mode, startPosition, loop) {
            this.initialize(mode, startPosition, loop, {})

            // Layer_1
            this.instance = new lib.CachedTexturedBitmap_2()
            this.instance.parent = this
            this.instance.setTransform(0, 0, 0.6512, 0.6512)

            this.timeline.addTween(cjs.Tween.get(this.instance).wait(1))

        }).prototype = getMCSymbolPrototype(lib.Oval, new cjs.Rectangle(0, 0, 31.9, 31.9), null);


        (lib.Symbol4 = function (mode, startPosition, loop) {
            this.initialize(mode, startPosition, loop, {})

            // Layer_1
            this.instance = new lib.CachedTexturedBitmap_4()
            this.instance.parent = this
            this.instance.setTransform(6.85, 6.85, 0.4167, 0.4167)

            this.instance_1 = new lib.Oval()
            this.instance_1.parent = this
            this.instance_1.setTransform(10.25, 10.25, 0.6398, 0.6398, 0, 0, 0, 16, 16)
            this.instance_1.alpha = 0.1992

            this.timeline.addTween(cjs.Tween.get({}).to({
                state: [{
                    t: this.instance_1
        }, {
                    t: this.instance
        }]
            }).wait(1))

        }).prototype = getMCSymbolPrototype(lib.Symbol4, new cjs.Rectangle(0, 0, 20.4, 20.4), null);


        // stage content:
        (lib.bentiu = function (mode, startPosition, loop) {
            this.initialize(mode, startPosition, loop, {
                pin: 1,
                line: 45,
                shape: 147,
                hidePin: 236
            })

            // timeline functions:
            this.frame_0 = function () {
                this.stop()
            }
            this.frame_44 = function () {
                this.stop()
            }
            this.frame_146 = function () {
                this.stop()
            }
            this.frame_235 = function () {
                this.stop()
            }
            this.frame_253 = function () {
                this.stop()
            }

            // actions tween:
            this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(44).call(this.frame_44).wait(102).call(this.frame_146).wait(89).call(this.frame_235).wait(18).call(this.frame_253).wait(1))

            // Layer_1
            this.instance = new lib.Symbol5()
            this.instance.parent = this
            this.instance.setTransform(133.15, 117.15, 1, 1, 0, 0, 0, 10.2, 14)
            this.instance._off = true

            this.timeline.addTween(cjs.Tween.get(this.instance).wait(27).to({
                _off: false
            }, 0).to({
                y: 135.25
            }, 11).wait(1).to({
                y: 132.25
            }, 0).wait(1).to({
                y: 135.25
            }, 0).wait(1).to({
                y: 132.25
            }, 0).wait(1).to({
                y: 135.25
            }, 0).wait(1).to({
                y: 132.25
            }, 0).wait(1).to({
                y: 135.25
            }, 0).wait(191).to({
                y: 112.25,
                alpha: 0
            }, 18).wait(1))

            // Layer_1
            this.instance_1 = new lib.Symbol4()
            this.instance_1.parent = this
            this.instance_1.setTransform(133.2, 147.95, 0.24, 0.24, 0, 0, 0, 10.4, 10.4)
            this.instance_1._off = true

            this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1).to({
                _off: false
            }, 0).to({
                regX: 10.3,
                regY: 10.3,
                scaleX: 1.2,
                scaleY: 1.2
            }, 18).to({
                regX: 10.2,
                regY: 10.2,
                scaleX: 1,
                scaleY: 1,
                x: 133.15,
                y: 147.9
            }, 7).wait(209).to({
                alpha: 0
            }, 18).wait(1))

            // mask_idn (mask)
            var mask = new cjs.Shape()
            mask._off = true
            var mask_graphics_45 = new cjs.Graphics().p('EgZoAtZMAAAhaxMAwxAAAMAAAA/VIAAAAIAAbcg')
            var mask_graphics_46 = new cjs.Graphics().p('EgZNAtZMAAAhaxMAwxAAAMAAAA/VIAAAAIAAbcg')
            var mask_graphics_47 = new cjs.Graphics().p('EgYyAtZMAAAhaxMAwxAAAMAAAA/UIAAAAIAAbdg')
            var mask_graphics_48 = new cjs.Graphics().p('EgYYAtZMAAAhaxMAwwAAAMAAAA/UIABAAIAAbdg')
            var mask_graphics_49 = new cjs.Graphics().p('EgYYAtZMAAAhaxMAwxAAAMAAAA/UIAAAAIAAbdg')
            var mask_graphics_50 = new cjs.Graphics().p('EgYYAtZMAAAhaxMAwwAAAMAAAA/UIABAAIAAbdg')
            var mask_graphics_51 = new cjs.Graphics().p('EgYYAtZMAAAhaxMAwxAAAMAAAA/VIAAAAIAAbcg')
            var mask_graphics_52 = new cjs.Graphics().p('EgYYAtZMAAAhaxMAwwAAAMAAAA/VIABAAIAAbcg')
            var mask_graphics_53 = new cjs.Graphics().p('EgYYAtZMAAAhaxMAwxAAAMAAAA/VIAAAAIAAbcg')
            var mask_graphics_54 = new cjs.Graphics().p('EgYYAtZMAAAhaxMAwwAAAMAAAA/UIABAAIAAbdg')
            var mask_graphics_55 = new cjs.Graphics().p('EgYYAtZMAAAhaxMAwxAAAMAAAA/UIAAAAIAAbdg')
            var mask_graphics_56 = new cjs.Graphics().p('EgYYAtZMAAAhaxMAwxAAAMAAAA/UIAAAAIAAbdg')
            var mask_graphics_57 = new cjs.Graphics().p('EgYYAtZMAAAhaxMAwwAAAMAAAA/UIABAAIAAbdg')
            var mask_graphics_58 = new cjs.Graphics().p('EgYYAtZMAAAhaxMAwwAAAMAAAA/VIABAAIAAbcg')
            var mask_graphics_59 = new cjs.Graphics().p('EgYYAtZMAAAhaxMAwxAAAMAAAA/VIAAAAIAAbcg')
            var mask_graphics_60 = new cjs.Graphics().p('EgYYAtZMAAAhaxMAwwAAAMAAAA/VIABAAIAAbcg')
            var mask_graphics_61 = new cjs.Graphics().p('EgYYAtZMAAAhaxMAwxAAAMAAAA/UIAAAAIAAbdg')
            var mask_graphics_62 = new cjs.Graphics().p('EgYYAtZMAAAhaxMAwwAAAMAAAA/UIABAAIAAbdg')
            var mask_graphics_63 = new cjs.Graphics().p('EgYYAtZMAAAhaxMAwwAAAMAAAA/UIABAAIAAbdg')
            var mask_graphics_64 = new cjs.Graphics().p('EgYYAtZMAAAhaxMAwxAAAMAAAA/UIAAAAIAAbdg')
            var mask_graphics_65 = new cjs.Graphics().p('EgYYAtZMAAAhaxMAwxAAAMAAAA/UIAAAAIAAbdg')
            var mask_graphics_66 = new cjs.Graphics().p('EgYYAtZMAAAhaxMAwwAAAMAAAA/UIABAAIAAbdg')
            var mask_graphics_67 = new cjs.Graphics().p('EgYYAtZMAAAhaxMAwxAAAMAAAA/UIAAAAIAAbdg')
            var mask_graphics_68 = new cjs.Graphics().p('EgYYAtZMAAAhaxMAwwAAAMAAAA/VIABAAIAAbcg')
            var mask_graphics_69 = new cjs.Graphics().p('EgYYAtZMAAAhaxMAwxAAAMAAAA/VIAAAAIAAbcg')
            var mask_graphics_70 = new cjs.Graphics().p('EgYYAtZMAAAhaxMAwxAAAMAAAA/VIAAAAIAAbcg')
            var mask_graphics_71 = new cjs.Graphics().p('EgYYAtZMAAAhaxMAwwAAAMAAAA/VIABAAIAAbcg')
            var mask_graphics_72 = new cjs.Graphics().p('EgYYAtZMAAAhaxMAwxAAAMAAAA/UIAAAAIAAbdg')
            var mask_graphics_73 = new cjs.Graphics().p('EgYYAtZMAAAhaxMAwwAAAMAAAA/UIABAAIAAbdg')
            var mask_graphics_74 = new cjs.Graphics().p('EgZQAtZMAAAhaxMAygAAAMAAAA/UIABAAIAAbdg')
            var mask_graphics_75 = new cjs.Graphics().p('EgaIAtZMAAAhaxMA0QAAAMAAAA/UIABAAIAAbdg')
            var mask_graphics_76 = new cjs.Graphics().p('EgbAAtZMAAAhaxMA2AAAAMAAAA/UIABAAIAAbdg')
            var mask_graphics_77 = new cjs.Graphics().p('Egb4AtZMAAAhaxMA3wAAAMAAAA/VIABAAIAAbcg')
            var mask_graphics_78 = new cjs.Graphics().p('EgcvAtZMAAAhaxMA5fAAAMAAAA/VIAAAAIAAbcg')
            var mask_graphics_79 = new cjs.Graphics().p('EgdnAtZMAAAhaxMA7PAAAMAAAA/VIAAAAIAAbcg')
            var mask_graphics_80 = new cjs.Graphics().p('EgefAtZMAAAhaxMA8/AAAMAAAA/VIAAAAIAAbcg')
            var mask_graphics_81 = new cjs.Graphics().p('EgfXAtZMAAAhaxMA+uAAAMAAAA/UIABAAIAAbdg')
            var mask_graphics_82 = new cjs.Graphics().p('EggPAtZMAAAhaxMBAeAAAMAAAA/UIABAAIAAbdg')
            var mask_graphics_83 = new cjs.Graphics().p('EghHAtZMAAAhaxMBCOAAAMAAAA/UIABAAIAAbdg')
            var mask_graphics_84 = new cjs.Graphics().p('Egh/AtZMAAAhaxMBD+AAAMAAAA/UIABAAIAAbdg')
            var mask_graphics_85 = new cjs.Graphics().p('Egi3AtZMAAAhaxMBFuAAAMAAAA/UIABAAIAAbdg')
            var mask_graphics_86 = new cjs.Graphics().p('EgjuAtZMAAAhaxMBHdAAAMAAAA/VIAAAAIAAbcg')
            var mask_graphics_87 = new cjs.Graphics().p('EgkmAtZMAAAhaxMBJNAAAMAAAA/UIAAAAIAAbdg')
            var mask_graphics_88 = new cjs.Graphics().p('EgleAtZMAAAhaxMBK8AAAMAAAA/VIABAAIAAbcg')
            var mask_graphics_89 = new cjs.Graphics().p('EgmWAtZMAAAhaxMBMsAAAMAAAA/VIABAAIAAbcg')
            var mask_graphics_90 = new cjs.Graphics().p('EgnOAtZMAAAhaxMBOcAAAMAAAA/UIABAAIAAbdg')
            var mask_graphics_91 = new cjs.Graphics().p('EgoGAtZMAAAhaxMBQMAAAMAAAA/VIABAAIAAbcg')
            var mask_graphics_92 = new cjs.Graphics().p('Ego+AtZMAAAhaxMBR8AAAMAAAA/UIABAAIAAbdg')
            var mask_graphics_93 = new cjs.Graphics().p('Egp2AtZMAAAhaxMBTsAAAMAAAA/UIABAAIAAbdg')
            var mask_graphics_94 = new cjs.Graphics().p('EgquAtZMAAAhaxMBVcAAAMAAAA/VIABAAIAAbcg')
            var mask_graphics_95 = new cjs.Graphics().p('EgrlAtZMAAAhaxMBXLAAAMAAAA/UIAAAAIAAbdg')
            var mask_graphics_96 = new cjs.Graphics().p('EgsdAtZMAAAhaxMBY6AAAMAAAA/VIABAAIAAbcg')
            var mask_graphics_97 = new cjs.Graphics().p('EgtVAtZMAAAhaxMBaqAAAMAAAA/VIABAAIAAbcg')
            var mask_graphics_98 = new cjs.Graphics().p('Eg4sAtZMAAAhaxMBxYAAAMAAAA/UIABAAIAAbdg')
            var mask_graphics_99 = new cjs.Graphics().p('Eg6yAqnMAEXhapMBxOAFcMgDDA/PIABAAIhUbag')
            var mask_graphics_100 = new cjs.Graphics().p('Eg8wAnvMAIuhaVMBwzAK4MgGFA/BIABAAIiobUg')
            var mask_graphics_101 = new cjs.Graphics().p('Eg+lAkxMANChZyMBwJAQRMgJGA+pIABAAIj8bJg')
            var mask_graphics_102 = new cjs.Graphics().p('EhARAhtMARWhZCMBvNAVpMgMGA+HIABAAIlQa7g')
            var mask_graphics_103 = new cjs.Graphics().p('EhBzAekMAVmhYFMBuBAa9MgPEA9dIABABImiaog')
            var mask_graphics_104 = new cjs.Graphics().p('EhDMAbXMAZ0hW8MBslAgOMgSAA8qIABAAIn0aTg')
            var mask_graphics_105 = new cjs.Graphics().p('EhEaAYGMAd8hVlMBq5AlZMgU5A7uIABAAIpDZ4g')
            var mask_graphics_106 = new cjs.Graphics().p('EhFfAUyMAiChUDMBo9AqgMgXwA6oIACAAIqTZbg')
            var mask_graphics_107 = new cjs.Graphics().p('EhGZARaMAmChSTMBmxAvgMgaiA5aIABAAIrgY5g')
            var mask_graphics_108 = new cjs.Graphics().p('EhHJAN/MAp8hQWMBkXA0YMgdRA4EIABAAIsrYTg')
            var mask_graphics_109 = new cjs.Graphics().p('EhHvAKjMAtxhOPMBhuA5JMgf8A2lIABABIt1Xqg')
            var mask_graphics_110 = new cjs.Graphics().p('EhIKAHFMAxfhL8MBe2A9yMgihA0/IABAAIu+W+g')
            var mask_graphics_111 = new cjs.Graphics().p('EhIaADmMA1FhJdMBbwBCRMglCAzQIABABIwDWNg')
            var mask_graphics_112 = new cjs.Graphics().p('EhIfAAHMA4jhG1MBYcBGoMgndAxZIABABIxGVbg')
            var mask_graphics_113 = new cjs.Graphics().p('EhIagDYMA75hECMBU8BKyMgpyAveIABAAIyHUlg')
            var mask_graphics_114 = new cjs.Graphics().p('EhIKgG3MA/GhBEMBRPBOyMgsBAtZIABABIzFTrg')
            var mask_graphics_115 = new cjs.Graphics().p('EhHwgKVMBCKg99MBNXBSnMguKArOIABABI0ASvg')
            var mask_graphics_116 = new cjs.Graphics().p('EhHLgNxMBFEg6tMBJTBWPMgwMAo9IABABI05Rwg')
            var mask_graphics_117 = new cjs.Graphics().p('EhGbgRMMBHzg3TMBFEBZrMgyHAmlIABABI1sQug')
            var mask_graphics_118 = new cjs.Graphics().p('EhFhgUkMBKYgzyMBArBc6Mgz6AkIIABABI2fPqg')
            var mask_graphics_119 = new cjs.Graphics().p('EhEdgX4MBMzgwJMA8IBf6Mg1mAhlIABABI3NOjg')
            var mask_graphics_120 = new cjs.Graphics().p('EhDOgbKMBPBgsZMA3cBitMg3JAe+IABABI35Nbg')
            var mask_graphics_121 = new cjs.Graphics().p('EhB2geXMBRFgoiMAyoBlQMg4lAcSIABABI4hMQg')
            var mask_graphics_122 = new cjs.Graphics().p('EhAUghgMBS9gkmMAtsBnmMg54AZiIAAABI5ELEg')
            var mask_graphics_123 = new cjs.Graphics().p('Eg+ogkkMBUnggkMAoqBpsMg7DAWuIABABI5lJ2g')
            var mask_graphics_124 = new cjs.Graphics().p('Eg80gniMBWHgcdMAjiBrhMg8FAT3IAAABI6BImg')
            var mask_graphics_125 = new cjs.Graphics().p('Eg62gqbMBXYgYSMAeVBtIMg89AQ8IAAABI6bHWg')
            var mask_graphics_126 = new cjs.Graphics().p('Eg4wgtNMBYegUEMAZDBueMg9uAOAIAAABI6vGEg')
            var mask_graphics_127 = new cjs.Graphics().p('Eg2hgv5MBZVgPyMATuBvkMg+VALBIAAABI7AExg')
            var mask_graphics_128 = new cjs.Graphics().p('Eg0NgyeMBaCgLhMAOZBwdMg+0AICIAAABI7ODfg')
            var mask_graphics_129 = new cjs.Graphics().p('Eg0KgyeMBaAgLeMAOVBwaMg+yAIAIAAABI7ODeg')
            var mask_graphics_130 = new cjs.Graphics().p('Eg0KgyeMBaAgLeMAOVBwaMg+yAIAIAAABI7ODeg')
            var mask_graphics_131 = new cjs.Graphics().p('Eg0KgyeMBaAgLeMAOVBwaMg+yAIAIAAABI7ODeg')
            var mask_graphics_132 = new cjs.Graphics().p('Eg0KgyeMBaAgLeMAOVBwaMg+yAIAIAAABI7ODeg')
            var mask_graphics_133 = new cjs.Graphics().p('Eg0KgyeMBaAgLeMAOVBwaMg+yAIAIAAABI7ODeg')
            var mask_graphics_134 = new cjs.Graphics().p('Eg0KgyeMBaAgLeMAOVBwaMg+yAIAIAAABI7ODeg')
            var mask_graphics_135 = new cjs.Graphics().p('Eg0KgyeMBaAgLeMAOVBwaMg+yAIAIAAABI7ODeg')
            var mask_graphics_136 = new cjs.Graphics().p('Eg0KgyeMBaAgLeMAOVBwaMg+yAIAIAAABI7ODeg')
            var mask_graphics_137 = new cjs.Graphics().p('Eg0KgyeMBaAgLeMAOVBwaMg+yAIAIAAABI7ODeg')
            var mask_graphics_138 = new cjs.Graphics().p('Eg0KgyeMBaAgLeMAOVBwaMg+yAIAIAAABI7ODeg')
            var mask_graphics_139 = new cjs.Graphics().p('Eg0KgyeMBaAgLeMAOVBwaMg+yAIAIAAABI7ODeg')
            var mask_graphics_140 = new cjs.Graphics().p('Eg0KgyeMBaAgLeMAOVBwaMg+yAIAIAAABI7ODeg')
            var mask_graphics_141 = new cjs.Graphics().p('Eg0KgyeMBaAgLeMAOVBwaMg+yAIAIAAABI7ODeg')
            var mask_graphics_142 = new cjs.Graphics().p('Eg0KgyeMBaAgLeMAOVBwaMg+yAIAIAAABI7ODeg')
            var mask_graphics_143 = new cjs.Graphics().p('Eg0KgyeMBaAgLeMAOVBwaMg+yAIAIAAABI7ODeg')
            var mask_graphics_144 = new cjs.Graphics().p('Eg0KgyeMBaAgLeMAOVBwaMg+yAIAIAAABI7ODeg')
            var mask_graphics_145 = new cjs.Graphics().p('Eg0KgyeMBaAgLeMAOVBwaMg+yAIAIAAABI7ODeg')
            var mask_graphics_146 = new cjs.Graphics().p('Eg0NgyeMBaCgLhMAOZBwdMg+0AICIAAABI7ODfg')

            this.timeline.addTween(cjs.Tween.get(mask).to({
                graphics: null,
                x: 0,
                y: 0
            }).wait(45).to({
                graphics: mask_graphics_45,
                x: -164.05,
                y: -134.95
            }).wait(1).to({
                graphics: mask_graphics_46,
                x: -161.375,
                y: -134.5
            }).wait(1).to({
                graphics: mask_graphics_47,
                x: -158.7,
                y: -134
            }).wait(1).to({
                graphics: mask_graphics_48,
                x: -155.95,
                y: -133.55
            }).wait(1).to({
                graphics: mask_graphics_49,
                x: -150.65,
                y: -133.1
            }).wait(1).to({
                graphics: mask_graphics_50,
                x: -145.3,
                y: -132.65
            }).wait(1).to({
                graphics: mask_graphics_51,
                x: -139.95,
                y: -132.15
            }).wait(1).to({
                graphics: mask_graphics_52,
                x: -134.6,
                y: -131.7
            }).wait(1).to({
                graphics: mask_graphics_53,
                x: -129.25,
                y: -131.25
            }).wait(1).to({
                graphics: mask_graphics_54,
                x: -123.9,
                y: -130.75
            }).wait(1).to({
                graphics: mask_graphics_55,
                x: -118.55,
                y: -130.3
            }).wait(1).to({
                graphics: mask_graphics_56,
                x: -113.25,
                y: -129.85
            }).wait(1).to({
                graphics: mask_graphics_57,
                x: -107.9,
                y: -129.4
            }).wait(1).to({
                graphics: mask_graphics_58,
                x: -102.55,
                y: -128.9
            }).wait(1).to({
                graphics: mask_graphics_59,
                x: -97.2,
                y: -128.45
            }).wait(1).to({
                graphics: mask_graphics_60,
                x: -91.85,
                y: -128
            }).wait(1).to({
                graphics: mask_graphics_61,
                x: -86.5,
                y: -127.5
            }).wait(1).to({
                graphics: mask_graphics_62,
                x: -81.15,
                y: -127.05
            }).wait(1).to({
                graphics: mask_graphics_63,
                x: -75.85,
                y: -126.6
            }).wait(1).to({
                graphics: mask_graphics_64,
                x: -70.5,
                y: -126.15
            }).wait(1).to({
                graphics: mask_graphics_65,
                x: -65.15,
                y: -125.65
            }).wait(1).to({
                graphics: mask_graphics_66,
                x: -59.8,
                y: -125.2
            }).wait(1).to({
                graphics: mask_graphics_67,
                x: -54.45,
                y: -124.75
            }).wait(1).to({
                graphics: mask_graphics_68,
                x: -49.1,
                y: -124.25
            }).wait(1).to({
                graphics: mask_graphics_69,
                x: -43.75,
                y: -123.8
            }).wait(1).to({
                graphics: mask_graphics_70,
                x: -38.45,
                y: -123.35
            }).wait(1).to({
                graphics: mask_graphics_71,
                x: -33.1,
                y: -122.9
            }).wait(1).to({
                graphics: mask_graphics_72,
                x: -27.75,
                y: -122.4
            }).wait(1).to({
                graphics: mask_graphics_73,
                x: -22.4,
                y: -121.95
            }).wait(1).to({
                graphics: mask_graphics_74,
                x: -13.0535,
                y: -121.75
            }).wait(1).to({
                graphics: mask_graphics_75,
                x: -3.707,
                y: -121.5
            }).wait(1).to({
                graphics: mask_graphics_76,
                x: 5.6412,
                y: -121.3
            }).wait(1).to({
                graphics: mask_graphics_77,
                x: 14.9877,
                y: -121.1
            }).wait(1).to({
                graphics: mask_graphics_78,
                x: 24.3342,
                y: -120.9
            }).wait(1).to({
                graphics: mask_graphics_79,
                x: 33.7308,
                y: -120.65
            }).wait(1).to({
                graphics: mask_graphics_80,
                x: 43.0773,
                y: -120.45
            }).wait(1).to({
                graphics: mask_graphics_81,
                x: 52.4238,
                y: -120.25
            }).wait(1).to({
                graphics: mask_graphics_82,
                x: 61.772,
                y: -120.05
            }).wait(1).to({
                graphics: mask_graphics_83,
                x: 71.1185,
                y: -119.8
            }).wait(1).to({
                graphics: mask_graphics_84,
                x: 80.465,
                y: -119.6
            }).wait(1).to({
                graphics: mask_graphics_85,
                x: 89.8115,
                y: -119.4
            }).wait(1).to({
                graphics: mask_graphics_86,
                x: 99.158,
                y: -119.2
            }).wait(1).to({
                graphics: mask_graphics_87,
                x: 108.5046,
                y: -118.95
            }).wait(1).to({
                graphics: mask_graphics_88,
                x: 117.8527,
                y: -118.75
            }).wait(1).to({
                graphics: mask_graphics_89,
                x: 127.1992,
                y: -118.55
            }).wait(1).to({
                graphics: mask_graphics_90,
                x: 136.5458,
                y: -118.35
            }).wait(1).to({
                graphics: mask_graphics_91,
                x: 145.9423,
                y: -118.1
            }).wait(1).to({
                graphics: mask_graphics_92,
                x: 155.2888,
                y: -117.9
            }).wait(1).to({
                graphics: mask_graphics_93,
                x: 164.6353,
                y: -117.7
            }).wait(1).to({
                graphics: mask_graphics_94,
                x: 173.9835,
                y: -117.5
            }).wait(1).to({
                graphics: mask_graphics_95,
                x: 183.33,
                y: -117.25
            }).wait(1).to({
                graphics: mask_graphics_96,
                x: 192.6765,
                y: -117.05
            }).wait(1).to({
                graphics: mask_graphics_97,
                x: 202.023,
                y: -116.85
            }).wait(1).to({
                graphics: mask_graphics_98,
                x: 185.5311,
                y: -114.1
            }).wait(1).to({
                graphics: mask_graphics_99,
                x: 199.2141,
                y: -105.0915
            }).wait(1).to({
                graphics: mask_graphics_100,
                x: 212.5008,
                y: -95.4099
            }).wait(1).to({
                graphics: mask_graphics_101,
                x: 225.2982,
                y: -85.0911
            }).wait(1).to({
                graphics: mask_graphics_102,
                x: 237.6239,
                y: -74.1682
            }).wait(1).to({
                graphics: mask_graphics_103,
                x: 249.3545,
                y: -62.6764
            }).wait(1).to({
                graphics: mask_graphics_104,
                x: 260.6134,
                y: -50.6432
            }).wait(1).to({
                graphics: mask_graphics_105,
                x: 271.1826,
                y: -38.1129
            }).wait(1).to({
                graphics: mask_graphics_106,
                x: 281.1369,
                y: -24.9648
            }).wait(1).to({
                graphics: mask_graphics_107,
                x: 290.5108,
                y: -11.4365
            }).wait(1).to({
                graphics: mask_graphics_108,
                x: 299.1835,
                y: 2.4808
            }).wait(1).to({
                graphics: mask_graphics_109,
                x: 307.1984,
                y: 16.8469
            }).wait(1).to({
                graphics: mask_graphics_110,
                x: 314.5782,
                y: 31.5767
            }).wait(1).to({
                graphics: mask_graphics_111,
                x: 321.2179,
                y: 46.6331
            }).wait(1).to({
                graphics: mask_graphics_112,
                x: 327.0562,
                y: 62.0166
            }).wait(1).to({
                graphics: mask_graphics_113,
                x: 332.2473,
                y: 77.6408
            }).wait(1).to({
                graphics: mask_graphics_114,
                x: 336.6165,
                y: 93.4647
            }).wait(1).to({
                graphics: mask_graphics_115,
                x: 340.2196,
                y: 109.5454
            }).wait(1).to({
                graphics: mask_graphics_116,
                x: 343.1106,
                y: 125.7414
            }).wait(1).to({
                graphics: mask_graphics_117,
                x: 345.1776,
                y: 142.0574
            }).wait(1).to({
                graphics: mask_graphics_118,
                x: 346.478,
                y: 158.456
            }).wait(1).to({
                graphics: mask_graphics_119,
                x: 347.0201,
                y: 174.9478
            }).wait(1).to({
                graphics: mask_graphics_120,
                x: 346.7128,
                y: 191.3868
            }).wait(1).to({
                graphics: mask_graphics_121,
                x: 345.5971,
                y: 207.8296
            }).wait(1).to({
                graphics: mask_graphics_122,
                x: 343.7503,
                y: 224.1934
            }).wait(1).to({
                graphics: mask_graphics_123,
                x: 341.1242,
                y: 240.4313
            }).wait(1).to({
                graphics: mask_graphics_124,
                x: 337.7461,
                y: 256.5099
            }).wait(1).to({
                graphics: mask_graphics_125,
                x: 333.519,
                y: 272.3827
            }).wait(1).to({
                graphics: mask_graphics_126,
                x: 328.615,
                y: 288.0692
            }).wait(1).to({
                graphics: mask_graphics_127,
                x: 322.8963,
                y: 303.5269
            }).wait(1).to({
                graphics: mask_graphics_128,
                x: 316.6705,
                y: 318.5458
            }).wait(1).to({
                graphics: mask_graphics_129,
                x: 314.1975,
                y: 318.67
            }).wait(1).to({
                graphics: mask_graphics_130,
                x: 311.8975,
                y: 318.67
            }).wait(1).to({
                graphics: mask_graphics_131,
                x: 309.5475,
                y: 318.67
            }).wait(1).to({
                graphics: mask_graphics_132,
                x: 307.2475,
                y: 318.67
            }).wait(1).to({
                graphics: mask_graphics_133,
                x: 304.9475,
                y: 318.67
            }).wait(1).to({
                graphics: mask_graphics_134,
                x: 302.5975,
                y: 318.67
            }).wait(1).to({
                graphics: mask_graphics_135,
                x: 300.2475,
                y: 318.67
            }).wait(1).to({
                graphics: mask_graphics_136,
                x: 297.9475,
                y: 318.67
            }).wait(1).to({
                graphics: mask_graphics_137,
                x: 295.5975,
                y: 318.67
            }).wait(1).to({
                graphics: mask_graphics_138,
                x: 293.2475,
                y: 318.67
            }).wait(1).to({
                graphics: mask_graphics_139,
                x: 290.9475,
                y: 318.67
            }).wait(1).to({
                graphics: mask_graphics_140,
                x: 288.5975,
                y: 318.67
            }).wait(1).to({
                graphics: mask_graphics_141,
                x: 286.2475,
                y: 318.67
            }).wait(1).to({
                graphics: mask_graphics_142,
                x: 283.9475,
                y: 318.67
            }).wait(1).to({
                graphics: mask_graphics_143,
                x: 281.5975,
                y: 318.67
            }).wait(1).to({
                graphics: mask_graphics_144,
                x: 279.2475,
                y: 318.67
            }).wait(1).to({
                graphics: mask_graphics_145,
                x: 276.9475,
                y: 318.67
            }).wait(1).to({
                graphics: mask_graphics_146,
                x: 274.6705,
                y: 318.5458
            }).wait(108))

            // Layer_7
            this.instance_2 = new lib.CachedTexturedBitmap_7()
            this.instance_2.parent = this
            this.instance_2.setTransform(1.5, 1.5, 0.5, 0.5)
            this.instance_2._off = true

            var maskedShapeInstanceList = [this.instance_2]

            for (var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
                maskedShapeInstanceList[shapedInstanceItr].mask = mask
            }

            this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(45).to({
                _off: false
            }, 0).wait(209))

            // mask_idn (mask)
            var mask_1 = new cjs.Shape()
            mask_1._off = true
            var mask_1_graphics_147 = new cjs.Graphics().p('A4210IVdAAIbfgeIAxeLIAANSI7dAAIgBAAI2PBIg')

            this.timeline.addTween(cjs.Tween.get(mask_1).to({
                graphics: null,
                x: 0,
                y: 0
            }).wait(147).to({
                graphics: mask_1_graphics_147,
                x: 163.575,
                y: 147.2625
            }).wait(107))

            // Layer_4
            this.instance_3 = new lib.Symbol2()
            this.instance_3.parent = this
            this.instance_3.setTransform(133.2, 147.95, 0.1188, 0.1188, 0, 0, 0, 130.8, 130.8)
            this.instance_3._off = true

            var maskedShapeInstanceList = [this.instance_3]

            for (var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
                maskedShapeInstanceList[shapedInstanceItr].mask = mask_1
            }

            this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(147).to({
                _off: false
            }, 0).to({
                regX: 130.6,
                regY: 130.6,
                scaleX: 4.3932,
                scaleY: 4.3932,
                x: 132.6,
                y: 155.05
            }, 88, cjs.Ease.cubicOut).wait(19))

        }).prototype = p = new cjs.MovieClip()
        p.nominalBounds = new cjs.Rectangle(0, 0, 325.5, 293)
            // library properties:
        lib.properties = {
            id: '1E425790439A4AD0BB931E93742EAA92',
            width: 600,
            height: 600,
            fps: 60,
            color: '#FFFFFF',
            opacity: 1.00,
            manifest: [
                {
                    src: 'images/CachedTexturedBitmap_3.png?1588244068260',
                    id: 'CachedTexturedBitmap_3'
        },
                {
                    src: 'images/bentiu_atlas_.png?1588244068218',
                    id: 'bentiu_atlas_'
        }
      ],
            preloads: []
        };


        // bootstrap callback support:

        (lib.Stage = function (canvas) {
            createjs.Stage.call(this, canvas)
        }).prototype = p = new createjs.Stage()

        p.setAutoPlay = function (autoPlay) {
            this.tickEnabled = autoPlay
        }
        p.play = function () {
            this.tickEnabled = true
            this.getChildAt(0).gotoAndPlay(this.getTimelinePosition())
        }
        p.stop = function (ms) {
            if (ms) this.seek(ms)
            this.tickEnabled = false
        }
        p.seek = function (ms) {
            this.tickEnabled = true
            this.getChildAt(0).gotoAndStop(lib.properties.fps * ms / 1000)
        }
        p.getDuration = function () {
            return this.getChildAt(0).totalFrames / lib.properties.fps * 1000
        }

        p.getTimelinePosition = function () {
            return this.getChildAt(0).currentFrame / lib.properties.fps * 1000
        }

        an.bootcompsLoaded = an.bootcompsLoaded || []
        if (!an.bootstrapListeners) {
            an.bootstrapListeners = []
        }

        an.bootstrapCallback = function (fnCallback) {
            an.bootstrapListeners.push(fnCallback)
            if (an.bootcompsLoaded.length > 0) {
                for (var i = 0; i < an.bootcompsLoaded.length; ++i) {
                    fnCallback(an.bootcompsLoaded[i])
                }
            }
        }

        an.compositions = an.compositions || {}
        an.compositions['1E425790439A4AD0BB931E93742EAA92'] = {
            getStage: function () {
                return exportRoot.getStage()
            },
            getLibrary: function () {
                return lib
            },
            getSpriteSheet: function () {
                return ss
            },
            getImages: function () {
                return img
            }
        }

        an.compositionLoaded = function (id) {
            an.bootcompsLoaded.push(id)
            for (var j = 0; j < an.bootstrapListeners.length; j++) {
                an.bootstrapListeners[j](id)
            }
        }

        an.getComposition = function (id) {
            return an.compositions[id]
        }


        an.makeResponsive = function (isResp, respDim, isScale, scaleType, domContainers) {
            var lastW, lastH, lastS = 1
            window.addEventListener('resize', resizeCanvas)
            resizeCanvas()
            rsc=resizeCanvas;
            
            function resizeCanvas() {
                var w = lib.properties.width,
                    h = lib.properties.height
                var iw = window.innerWidth,
                    ih = window.innerHeight
                var pRatio = window.devicePixelRatio || 1,
                    xRatio = iw / w,
                    yRatio = ih / h,
                    sRatio = 1
                if (isResp) {
                    if ((respDim == 'width' && lastW == iw) || (respDim == 'height' && lastH == ih)) {
                        sRatio = lastS
                    } else if (!isScale) {
                        if (iw < w || ih < h)
                            sRatio = Math.min(xRatio, yRatio)
                    } else if (scaleType == 1) {
                        sRatio = Math.min(xRatio, yRatio)
                    } else if (scaleType == 2) {
                        sRatio = Math.max(xRatio, yRatio)
                    }
                }


                ///////////////////////////
                ///////////////////////////


                var widthHelper = domContainers[1].parentElement
                var whw = widthHelper.offsetWidth
                sRatio = whw / ART_W
                //>>


                domContainers[0].width = w * pRatio * sRatio
                domContainers[0].height = h * pRatio * sRatio
                domContainers.forEach(function (container) {
                    container.style.width = w * sRatio + 'px'
                    container.style.height = h * sRatio + 'px'
                })
                stage.scaleX = pRatio * sRatio
                stage.scaleY = pRatio * sRatio
                lastW = iw
                lastH = ih
                lastS = sRatio
                stage.tickOnUpdate = false
                stage.update()
                stage.tickOnUpdate = true
                    
                //console.log(canvas1)
                  canvas1.style.height = 600 * sRatio/1.6 + 'px'
                canvas1.style.width = 600 * sRatio/1.6 + 'px'
              

                ///////////////////////////////////////////
                ///////////////////////////////////////////
                ///////////////////////////////////////////
                ///////////////////////////////////////////
                ///////////////////////////////////////////

                //REPOSITION

                //console.log(domContainers[1].parentElement.getBoundingClientRect().y,'>>')
                var y = window.innerHeight - ART_H * sRatio
                y /= 2
                //var parentY=domContainers[1].parentElement.style.top
                var parentY=domContainers[1].parentElement.getBoundingClientRect().y
                y-=parentY
                    //animation-position-helper
                domContainers[1].style.top = y + "px";






            }
        }


    })(createjs, AdobeAn)

    let box = function () {

        var currentProgress = 0

        var path = [205.99, 15.52, 9, 15.52, 9, 420.68, 124.67, 414.73, 213.15, 410.47, 466, 410.47, 466, 289.08, 459.01, 11.1]
        var density = .1
        var force = .8
            // initial circles, doubled later
        
                

        var numCircles = (window.innerWidth< 500)? 100 : 300;
        console.log(numCircles);
        
        var X = 3
        var Y = 5

        ////////////////////////////////////

        var MaxSpeed = force
        var doubling = false
        var creating = numCircles
        var exportRoot


        function init_(exportRoot_) {
            exportRoot = exportRoot_
                ///////////////////////////////////////////////// debug draw
            debugDraw = new b2DebugDraw()
                //debugDraw.SetSprite(document.getElementById('canvas1').getContext('2d'))
            debugDraw.SetSprite(canvas1.getContext('2d'))
            //>>>
            debugDraw.SetDrawScale(30.0*1.6)
            debugDraw.SetFillAlpha(0)

            debugDraw.SetAlpha(0)
                //debugDraw.SetLineThickness(0);
            debugDraw.SetFlags(b2DebugDraw.e_shapeBit | b2DebugDraw.e_jointBit)
            world.SetDebugDraw(debugDraw)
        }


        var b2Vec2 = Box2D.Common.Math.b2Vec2,
            b2AABB = Box2D.Collision.b2AABB,
            b2BodyDef = Box2D.Dynamics.b2BodyDef,
            b2Body = Box2D.Dynamics.b2Body,
            b2FixtureDef = Box2D.Dynamics.b2FixtureDef,
            b2Fixture = Box2D.Dynamics.b2Fixture,
            b2World = Box2D.Dynamics.b2World,
            b2MassData = Box2D.Collision.Shapes.b2MassData,
            b2PolygonShape = Box2D.Collision.Shapes.b2PolygonShape,
            b2CircleShape = Box2D.Collision.Shapes.b2CircleShape,
            b2EdgeChainDef = Box2D.Collision.Shapes.b2EdgeChainDef,
            b2DebugDraw = Box2D.Dynamics.b2DebugDraw,
            b2Color = Box2D.Common.b2Color,
            b2MouseJointDef = Box2D.Dynamics.Joints.b2MouseJointDef

        var world = new b2World(
            new b2Vec2(0, 0) //gravity
            , true //allow sleep
        )
        var debugDraw
        var fixDef = new b2FixtureDef

        fixDef.density = density
        fixDef.friction = 0
        fixDef.restitution = .999999

        var bodyDef = new b2BodyDef
        bodyDef.type = b2Body.b2_staticBody


        //////////////////////////////////////////////// walls

        fixDef.shape = new b2PolygonShape()
        for (var i = 0; i < path.length; i += 2) {

            var scale = .023

            if (i < (path.length - 2)) {
                var x0 = path[i] * scale
                var y0 = path[i + 1] * scale
                var x1 = path[i + 2] * scale
                var y1 = path[i + 3] * scale
            } else {
                var x0 = path[i] * scale
                var y0 = path[i + 1] * scale
                var j = i - (path.length - 2)

                var x1 = path[j + 0] * scale
                var y1 = path[j + 1] * scale


            }
            fixDef.shape.SetAsEdge(new b2Vec2(x0, y0), new b2Vec2(x1, y1))
            var b = world.CreateBody(bodyDef)
            b.CreateFixture(fixDef)
            b.wall = true
        }


        //////////////////////////////////////////////// contact
        var contactListener = new Box2D.Dynamics.b2ContactListener
        contactListener.BeginContact = function (contact) {
            var manifold = new Box2D.Collision.b2WorldManifold
            contact.GetWorldManifold(manifold)
            var contactPoint = manifold.m_points[0]
                //contactPoint=manifold.m_normal;


            var a = contact.GetFixtureA().GetBody()
            var b = contact.GetFixtureB().GetBody()

            var vel = b.GetLinearVelocity()
                //console.log(vel)
            var speed = vel.Normalize()
                //      console.log(vel,speed)
            
            var mr=Math.random()
            if (mr > .99) {
                vel.Multiply(MaxSpeed + mr)
                b.SetLinearVelocity(vel)
            }
            // console.log(b.GetLinearVelocity())
            if (a.wall || b.wall) {

                if (a.wall) {

                    var force = .005
                    var ac = contactPoint
                    var bc = b.GetWorldCenter()

                    var dx = ac.x - bc.x
                    var dy = ac.y - bc.y


                    // b.ApplyImpulse(new b2Vec2(Math.random() * force - force / 2, Math.random() * force - force / 2), b.GetWorldCenter());
                    b.ApplyImpulse(new b2Vec2(dx * .01, dy * .01), b.GetWorldCenter())

                }


            } else {

                a.poison = b.poison || a.poison
                b.poison = b.poison || a.poison
            }


            // console.log("+")
            // if else statement here...

        }

        world.SetContactListener(contactListener)


        //   window.setInterval(update, 1000 / 60);


        bodyDef.type = b2Body.b2_dynamicBody
        fixDef.shape = new b2CircleShape(
                .08
            )
            //          bodyDef.position.x = X //Math.random() * 10;
            //          bodyDef.position.y = Y //Math.random() * 10;

        //////////////////////////////////////////////////////////// game tick

        function update(step) {
            if(paused)return
            if (creating > 0) {
                //create some objects

                for (var i = 0; i < 3; ++i) {
                    bodyDef.position.x = X + Math.random() * 3
                    bodyDef.position.y = Y + Math.random() * 3


                    var body = world.CreateBody(bodyDef)
                    body.CreateFixture(fixDef)
                    body.ApplyForce(new b2Vec2(Math.random() * force - force / 2, Math.random() * force - force / 2), body.GetWorldCenter())

                    creating--
                }

            }
            if (doubling) {
                //            for (b = world.m_bodyList; b; b = b.m_next) {
                //
                //
                //            }
                var body = world.m_bodyList

                while (body) {

                    var p = body.GetWorldCenter()

                    bodyDef.position.x = p.x
                    bodyDef.position.y = p.y


                    ///hack
                    if (p.x != 0) {

                        var b = world.CreateBody(bodyDef)
                        b.CreateFixture(fixDef)
                        b.ApplyForce(new b2Vec2(Math.random() * force - force / 2, Math.random() * force - force / 2), b.GetWorldCenter())
                    }
                    body = body.m_next


                }

                doubling = false

            }

            world.Step(1 / 60, 10, 10)
            world.DrawDebugData()
            world.ClearForces()

            window.requestAnimationFrame(update)
        }
            
        start2dSim=function(){
            window.requestAnimationFrame(update)
        }

        var vec, selectedBody

        function getBodyAtCP() {

            vec = new b2Vec2(X, Y)

            var aabb = new b2AABB()
            aabb.lowerBound.Set(X - 1, Y - 1)
            aabb.upperBound.Set(X + 1, Y + 1)

            // Query the world for overlapping shapes.

            selectedBody = null
            world.QueryAABB(getBodyCB, aabb)
            return selectedBody
        }

        function getBodyCB(fixture) {
            if (fixture.GetBody().GetType() != b2Body.b2_staticBody) {
                // if (fixture.GetShape().TestPoint(fixture.GetBody().GetTransform(), vec)) {
                selectedBody = fixture.GetBody()
                return false
                    //}
            }
            return true
        }


        function next_() {
            rsc();
            switch (currentProgress) {
            case 0:
                window.requestAnimationFrame(update)

                exportRoot.gotoAndPlay('pin')
                break

            case 1:
                exportRoot.gotoAndPlay('line')
                break

            case 2:
                exportRoot.gotoAndPlay('shape')
                break

            case 3:

                exportRoot.gotoAndPlay('hidePin')
                debugDraw.SetFillAlpha(1)
                break


            case 4:
                doubling = true
                break


            case 5:

                var b = getBodyAtCP()
                if (b) {
                    b.poison = true
                }
            }
            currentProgress++


        }

        world.DrawDebugData = function () {
            if (this.m_debugDraw == null) {
                return
            }
            this.m_debugDraw.m_sprite.graphics.clear()
            var flags = this.m_debugDraw.GetFlags()
            var i = 0
            var b
            var f
            var s
            var j
            var bp
            var invQ = new b2Vec2
            var x1 = new b2Vec2
            var x2 = new b2Vec2
            var xf
            var b1 = new b2AABB()
            var b2 = new b2AABB()
            var vs = [new b2Vec2(), new b2Vec2(), new b2Vec2(), new b2Vec2()]
            var color = new b2Color(0, 0, 0)
            if (flags & b2DebugDraw.e_shapeBit) {
                for (b = this.m_bodyList; b; b = b.m_next) {
                    xf = b.m_xf
                    for (f = b.GetFixtureList(); f; f = f.m_next) {
                        s = f.GetShape()

                        if (b.poison) {
                            color.Set(0.7725490196, 0.09019607843, 0.14117647058)
                            this.DrawShape(s, xf, color)
                        } else {
                            color.Set(0.40784313725 , 0.53333333333, 0.47058823529 )

                            this.DrawShape(s, xf, color)
                        }
                    }
                }
            }

        }

        return {
            next: function () {
                next_()
            },
            init: function (rut) {
                init_(rut)
            }
        }
    }()

    var map = function () {
        var canvas, exportRoot, anim_container, dom_overlay_container, fnStartAnimation
        var loadCompleted
        var initialised_
        var loaded_
        var promise_
        var comp

        var loader = new createjs.LoadQueue(false)

        promise_ = new Promise((resolve, reject) => {
            loader.addEventListener('complete', function (evt) {
                resolve(box.next)
                handleComplete(evt, comp)
            })
        })

        function init_(anim_containerParam, canvasParam, canvas1Param, dom_overlay_containerParam) {

            canvas = canvasParam
            canvas1 = canvas1Param
            anim_container = anim_containerParam
            dom_overlay_container = dom_overlay_containerParam
            comp = AdobeAn.getComposition('1E425790439A4AD0BB931E93742EAA92')
            var lib = comp.getLibrary()
                //var loader = new createjs.LoadQueue(false);
            loader.addEventListener('fileload', function (evt) {
                    handleFileLoad(evt, comp)
                })
                //        promise_ = new Promise((resolve, reject) => {
                //            loader.addEventListener("complete", function (evt) {
                //                resolve(box.next);
                //                handleComplete(evt, comp)
                //            });
                //        });
                //        loader.addEventListener("complete", function (evt) {
                //
                //            handleComplete(evt, comp)
                //        });
            var lib = comp.getLibrary()
            loader.loadManifest(lib.properties.manifest)
        }


        function handleFileLoad(evt, comp) {
            var images = comp.getImages()
            if (evt && (evt.item.type == 'image')) {
                images[evt.item.id] = evt.result
            }
        }

        function handleComplete(evt) {
            //This function is always called, irrespective of the content. You can use the variable "stage" after it is created in token create_stage.
            var lib = comp.getLibrary()
            var ss = comp.getSpriteSheet()
            var queue = evt.target
            var ssMetadata = lib.ssMetadata
            for (var i = 0; i < ssMetadata.length; i++) {
                ss[ssMetadata[i].name] = new createjs.SpriteSheet({
                    'images': [queue.getResult(ssMetadata[i].name)],
                    'frames': ssMetadata[i].frames
                })
            }
            exportRoot = new lib.bentiu()
            stage = new lib.Stage(canvas)
                //Registers the "tick" event listener.
            fnStartAnimation = function () {
                    stage.addChild(exportRoot)
                    createjs.Ticker.setFPS(lib.properties.fps)
                    createjs.Ticker.addEventListener('tick', stage)
                }
                //Code to support hidpi screens and responsive scaling.
            AdobeAn.makeResponsive(true, 'both', false, 1, [canvas, anim_container, dom_overlay_container, canvas1])
            AdobeAn.compositionLoaded(lib.properties.id)
            fnStartAnimation()
            box.init(exportRoot)
            loadCompleted = true
        }
        
        function pause_(toPause){
            toPause=toPause===undefined
            if(!loadCompleted)return;
//            if(toPause){
//                createjs.Ticker.removeEventListener('tick', stage);
//            }else{
//                createjs.Ticker.addEventListener('tick', stage);
//                
//            }
            rsc();
            paused=toPause;
            if(!paused)
                start2dSim();
        }

        return {
            pause:pause_,
            init: init_,
            ready: promise_

        }
    }()




    return map
})(createjs, Box2D, )

export default map;